export enum ScreenPerformance {
  HOME = 'HomeOnlineScreen',
  PROFILE = 'ProfileOnlineScreen',
  SEARCH = 'SearchOnlineScreen',
  THEMATIC_HOME = 'ThematicHomeScreen',
  LOGIN = 'LoginScreen',
}
